/**
 * Privacy types for chart creation and display
 * Enables screen-sharing safe mode with masked coordinates and addresses
 */

export type PrivacyMode = 'rough' | 'precise';

export type CoordinateFormat = 'decimal' | 'dms';

export interface PrivacySettings {
  mode: PrivacyMode;
  coordinateFormat: CoordinateFormat;
  showMap: boolean;
  coordinatesMasked: boolean;
}

export interface DMSCoordinate {
  degrees: number;
  minutes: number;
  seconds: number;
  direction: 'N' | 'S' | 'E' | 'W';
}

export interface FormattedCoordinates {
  latitude: string;
  longitude: string;
  latitudeDMS?: DMSCoordinate;
  longitudeDMS?: DMSCoordinate;
}

export const DEFAULT_PRIVACY_SETTINGS: PrivacySettings = {
  mode: 'precise',
  coordinateFormat: 'decimal',
  showMap: false, // Map hidden by default for privacy
  coordinatesMasked: true
};

// localStorage keys
export const PRIVACY_STORAGE_KEY = 'hora-privacy-settings';
